(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/main.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/main.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  showLoaderAtom = _svs$iam_idp$atoms.showLoaderAtom,
  showFallbackAtom = _svs$iam_idp$atoms.showFallbackAtom,
  showFallbackQrAtom = _svs$iam_idp$atoms.showFallbackQrAtom;
const _svs$iam_idp$componen = svs.iam_idp.components.media_queries,
  Mobile = _svs$iam_idp$componen.Mobile,
  Desktop = _svs$iam_idp$componen.Desktop;
const Footer = svs.iam_idp.components.footer.Footer;
const Main = () => {
  const isMobile = svs.core.detect.formfactor.mobile();
  const showLoader = useAtomValue(showLoaderAtom);
  const showFallback = useAtomValue(showFallbackAtom);
  const showFallbackQr = useAtomValue(showFallbackQrAtom);
  const shouldShowFooter = isMobile ? !showLoader && !showFallback && !showFallbackQr : !showLoader;
  return React.createElement("section", {
    className: "main-section"
  }, React.createElement("div", {
    className: "login-section"
  }, isMobile ? React.createElement(Mobile, null) : React.createElement(Desktop, null), shouldShowFooter && React.createElement(Footer, null)));
};
svs.iam_idp.Main = Main;

 })(window);